import DateFnsUtils from "@date-io/date-fns";
import {
  Button,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import { COVID_19_SUCCESS } from "navigation/CONSTANTS";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  getDistricts,
  saveRegistrationForm,
  getUserName,
} from "services/registrations";
import InputBox from "./components/InputBox";
import { SET_EMPTY } from "config";

const useStyles = makeStyles((theme) => ({
  header: {
    border: `1px solid #dadce0`,
    padding: 16,
    wordWrap: "break-word",
    pageBreakInside: "avoid",
    background: "#fff",
    borderRadius: 8,
    borderTopWidth: 10,
    borderTopColor: theme.palette.primary.main,
  },
  box: {
    border: `1px solid #dadce0`,
    padding: 16,
    wordWrap: "break-word",
    pageBreakInside: "avoid",
    background: "#fff",
    borderRadius: 8,
  },
  form: {
    "&>*": {
      marginBottom: 16,
    },
  },
}));

const fullyVaccinatedBooster = "fullyVaccinatedBooster";
const requestVaccineInfo = [
  "fullyVaccinated",
  "partiallyVaccinated",
  "fullyVaccinatedBooster",
];

const AltRegistration = () => {
  const theme = useTheme();
  const classes = useStyles();
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [districts, setDistricts] = useState([]);
  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [empNameWarning, setEmpNameWarning] = useState(false);
  const [empNameDisabled, setEmpNameDisabled] = useState(false);
  const history = useHistory();
  // const [empIdError, setEmpIdError] = useState(false);

  useEffect(() => {
    const header = document.querySelector("#header-bar");
    const testEnv = document.querySelector(".imtime-testEnvironment");
    if (header) header.style.display = "none";
    if (testEnv) testEnv.style.display = "none";
  }, []);

  const reset = () => {
    setData({});
    setErrors({});
    setHasError(false);
    // Reload the page
    // eslint-disable-next-line no-self-assign
    window.location = window.location;
  };

  useEffect(() => {
    getDistricts()
      .then((data) => {
        setDistricts(data);
        setLoading(false);
      })
      .catch((e) => {
        setDistricts([]);
      });
  }, []);

  const getName = async (id, value) => {
    if( id && value && value.length>5){
    await getUserName(value)
      .then(
        (data) => (
          setData((p) => ({ ...p, ["name"]: data })),
          data
            ? (setData((p) => ({ ...p, ["name"]: data.trim() })),
              setEmpNameWarning(false),
              setEmpNameDisabled(true))
            : (
              setEmpNameWarning(true),
              setEmpNameDisabled(false))
        )
      )
      .catch((e) => {
        console.log("ERROR IN GET NAME" + e);
      });
    }
    else if(value && value.length>=0){
      setEmpNameWarning(false);
      setEmpNameDisabled(false);
    }
  };

  const handleChange = (id, value) => {
    if (id === "empid" ) {
      setData((p) => {
        let n = { ...p };
        delete n.name;
        return n;
      });
      getName(id, value);
    }
    else if (id === "name" && value && value.length > 0) setEmpNameWarning(false);
    else if (id === "vaccination_date") {
      setData((p) => {
        let n = { ...p };
        delete n.booster_date;
        return n;
      });
    }
    setData((p) => ({ ...p, [id]: value }));
    setHasError(false);
    setErrors((p) => {
      let n = { ...p };
      delete n.vaccination_date;
      delete n.booster_date;
      return n;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let dataToSubmit = { ...data };
    if (requestVaccineInfo.includes(data.vaccinated)) {
      if (!data.vaccination_date) {
        setErrors((p) => ({ ...p, vaccination_date: "This is required" }));
        setHasError(true);
        return;
      } else setHasError(false);
    }

    if (!requestVaccineInfo.includes(data.vaccinated)) {
      delete dataToSubmit.vaccination_date;
      delete dataToSubmit.vaccine;
      delete dataToSubmit.booster_date;
      delete dataToSubmit.booster;
    }
    if (!(fullyVaccinatedBooster === data.vaccinated)) {
      delete dataToSubmit.booster_date;
      delete dataToSubmit.booster;
    }

    if (fullyVaccinatedBooster == data.vaccinated) {
      if (!data.booster_date) {
        setErrors((p) => ({ ...p, booster_date: "This is required" }));
        setHasError(true);
        return;
      } else if (
        data.booster_date &&
        data.vaccination_date &&
        data.booster_date < data.vaccination_date
      ) {
        setErrors((p) => ({
          ...p,
          booster_date: "booster date should be after vaccination date",
        }));
        setHasError(true);
        return;
      } else setHasError(false);
    }

    console.log("Data", dataToSubmit);
    // setSaving(true);
    // getUserDetails(dataToSubmit.empid)
    //   .then((data) => {
    //     if (data && data.data() && data.data().actionBy) {
    //       setEmpIdError(false);
    //       doSave(dataToSubmit);
    //     } else {
    //       setSaving(false);
    //       setEmpIdError(true);
    //     }
    //   })
    //   .catch((err) =>
    //     console.log("Err in get User Detail>>Alt-registration form" + err)
    //   );
    doSave(dataToSubmit);
  };

  const doSave = async (data) => {
    setSaving(true);
    const info = {
      purpose: "Covid 19 vaccination details",
      key: "covid19",
    };
    try {
      await saveRegistrationForm(data, info);
      history.push(COVID_19_SUCCESS);
    } catch (e) {
      console.error(e);
    }
    setSaving(false);
  };
  const getMinDate = () => {
    if (
      data &&
      data.vaccinated &&
      data.vaccinated == fullyVaccinatedBooster &&
      data.vaccination_date
    )
      return new Date(moment(data.vaccination_date).add(1, "days"));
    else return new Date("01/01/2020");
  };

  return (
    <>
      {loading ? (
        <Container
          maxWidth="sm"
          style={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
          <Typography style={{ marginTop: 16 }}>Loading form...</Typography>
        </Container>
      ) : (
        <Container
          maxWidth="sm"
          style={{ paddingBottom: 148, paddingTop: 24, flexGrow: 1 }}
        >
          <Grid
            container
            item
            id="vaccine_form"
            direction="column"
            alignItems="stretch"
            className={classes.form}
            component="form"
            onSubmit={handleSubmit}
          >
            <Grid
              item
              container
              className={classes.header}
              direction="column"
              alignItems="stretch"
            >
              <Grid item>
                <Typography style={{ fontSize: 20 }}>
                  Vaccine Attestation Form
                </Typography>
              </Grid>
              <Grid item style={{ marginTop: 16 }}>
                <Typography style={{ fontSize: 14 }} color="textPrimary">
                  Form for getting vaccination inputs.
                </Typography>
              </Grid>
            </Grid>
            <InputBox
              title="Employee ID"
              type="text"
              id="empid"
              onChange={handleChange}
              required={true}
              placeholder={"Enter Employee ID"}
              // error={empIdError}
              // helperText="Employee not found!"
            />
            <InputBox
              title="Employee Name"
              type="text"
              id="name"
              onChange={handleChange}
              required={true}
              value={data && data.name ? data.name : SET_EMPTY}
              placeholder={"Enter Employee Name"}
              helperText={empNameWarning && "Worker not found"}
              disabled={empNameDisabled}
            />

            <InputBox
              title="District - City"
              type="dropdown"
              options={districts}
              getOptionLabel={(option) => option.id}
              id="district"
              onChange={handleChange}
              getReturnValue={(value) => value.id}
              required={true}
              placeholder={"Select your District or City"}
            />
            <Grid
              item
              container
              className={classes.box}
              direction="column"
              alignItems="stretch"
            >
              <Grid item>
                <Typography style={{ fontSize: 16 }} component="span">
                  Please select one of the following responses
                </Typography>

                <Typography
                  component="span"
                  style={{
                    fontSize: 16,
                    marginLeft: 8,
                    color: theme.palette.error.main,
                  }}
                >
                  *
                </Typography>
              </Grid>
              <Grid item style={{ marginTop: 16 }}>
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="gender"
                    name="vaccinated"
                    onChange={(e, v) => handleChange("vaccinated", v)}
                  >
                    <FormControlLabel
                      style={{ fontSize: 14 }}
                      value="fullyVaccinatedBooster"
                      control={<Radio color="primary" required />}
                      label="Fully vaccinated + Booster"
                    />
                    <FormControlLabel
                      style={{ fontSize: 14 }}
                      value="fullyVaccinated"
                      control={<Radio color="primary" required />}
                      label="Fully vaccinated"
                    />
                    <FormControlLabel
                      style={{ fontSize: 14 }}
                      value="partiallyVaccinated"
                      control={<Radio color="primary" required />}
                      label="Partially vaccinated"
                    />
                    <FormControlLabel
                      style={{ fontSize: 14 }}
                      value="notVaccinated"
                      control={<Radio color="primary" required />}
                      label="Not vaccinated"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
            {data.vaccinated && requestVaccineInfo.includes(data.vaccinated) && (
              <>
                <InputBox
                  required={true}
                  title="Vaccine name"
                  type="dropdown"
                  options={[
                    { id: "moderna", label: "Moderna" },
                    { id: "pfizer", label: "Pfizer" },
                    { id: "johnsonJo", label: "Johnson & Johnson" },
                    { id: "astrazeneca", label: "AstraZeneca" },
                  ]}
                  getReturnValue={(value) => value.id}
                  id="vaccine"
                  onChange={handleChange}
                  placeholder={"Select vaccination manufacturer"}
                />
                <Grid
                  item
                  container
                  className={classes.box}
                  direction="column"
                  alignItems="stretch"
                >
                  <Grid item>
                    <Typography style={{ fontSize: 16 }} component="span">
                      Vaccination date
                    </Typography>
                    <Typography
                      component="span"
                      style={{
                        fontSize: 16,
                        marginLeft: 8,
                        color: theme.palette.error.main,
                      }}
                    >
                      *
                    </Typography>
                  </Grid>
                  <Grid item style={{ marginTop: 16 }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        fullWidth
                        error={errors.vaccination_date ? true : false}
                        value={
                          data.vaccination_date ? data.vaccination_date : null
                        }
                        disableFuture
                        placeholder="Select date of most recent dose"
                        onChange={(date) =>
                          handleChange(
                            "vaccination_date",
                            moment(date).format("YYYY/MM/DD")
                          )
                        }
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                </Grid>
                {data.vaccinated && data.vaccinated == fullyVaccinatedBooster && (
                  <>
                    <InputBox
                      required={true}
                      title="Booster name"
                      type="dropdown"
                      options={[
                        { id: "moderna", label: "Moderna" },
                        { id: "pfizer", label: "Pfizer" },
                        { id: "johnsonJo", label: "Johnson & Johnson" },
                        { id: "astrazeneca", label: "AstraZeneca" },
                      ]}
                      getReturnValue={(value) => value.id}
                      id="booster"
                      onChange={handleChange}
                      placeholder={"Select Booster manufacturer"}
                    />

                    <Grid
                      item
                      container
                      className={classes.box}
                      direction="column"
                      alignItems="stretch"
                    >
                      <Grid item>
                        <Typography style={{ fontSize: 16 }} component="span">
                          Booster date
                        </Typography>
                        <Typography
                          component="span"
                          style={{
                            fontSize: 16,
                            marginLeft: 8,
                            color: theme.palette.error.main,
                          }}
                        >
                          *
                        </Typography>
                      </Grid>
                      <Grid item style={{ marginTop: 16 }}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <DatePicker
                            fullWidth
                            error={errors.booster_date ? true : false}
                            value={data.booster_date ? data.booster_date : null}
                            disableFuture
                            minDate={getMinDate()}
                            placeholder="Select date of most recent dose"
                            onChange={(date) =>
                              handleChange(
                                "booster_date",
                                moment(date).format("YYYY/MM/DD")
                              )
                            }
                          />
                        </MuiPickersUtilsProvider>
                      </Grid>
                    </Grid>
                  </>
                )}
              </>
            )}

            <Grid
              item
              container
              className={classes.box}
              direction="column"
              alignItems="stretch"
            >
              <Grid item>
                <Typography variant="caption">
                  The information I am submitting is accurate and truthful. I
                  understand that providing false information will be grounds
                  for disciplinary action including termination. I also
                  understand that Iron Mountain may request that I provide proof
                  of vaccination when required due to a legal requirement,
                  customer request or other business need, and I will promptly
                  comply with any such request.
                </Typography>
              </Grid>
              <Grid
                item
                style={{
                  marginTop: 16,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  disabled={saving}
                  type="submit"
                  variant="contained"
                  color="primary"
                  disableElevation
                  style={{ textTransform: "none" }}
                >
                  {saving && <CircularProgress size={24} />}
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      )}
    </>
  );
};

export default AltRegistration;
